import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal';
import cl from './DealerDebtModal.module.css'
import tbl from '../../../../assets/Style/Table.module.css'
import Form from '../../../../assets/Style/Form.module.css'

import { useTransaction } from '../../../../hooks/useTransactions';
import Select from "react-select"; 
import { selectStyle } from './selectStyle';
import { AppContext } from '../../../../providers/appProvider';
import { useTranslation } from 'react-i18next';

function DealerDebtModal({ carId, dealerId, amount, carService, dealerPage }) {

    const { appState, app } = useContext(AppContext);
    const { t } = useTranslation();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [inputValues, setInputValues] = useState({});
    const [debtCars, setDebtCars] = useState([]);
    const [depositCars, setDepositCars] = useState([]);

    const [transactions, setTransactions] = useState([]);
    const [textInputValues, setTextInputValues] = useState({});

    const { transactionService } = useTransaction()

    const debtOptions = debtCars.map((car) => {
        if (car.id === carId) {
            return { value: car.id, label: t('CommissionRefund') };
        }
        return { value: car.id, label: t('DebtCarOption', { vin: car.vin, amount: car.client_debt }) };
    });

    const sumOfAmountDeposit = depositCars.reduce((acc, item) => acc + (item.client_price_dealer + item.client_price_dealer_transport), 0);

    const refreshData = () => {
        carService.fetchByDealerIdDebt(dealerId)
            .then(cars => setDebtCars(cars))

        carService.fetchByDealerIdDeposit(dealerId)
            .then(cars => setDepositCars(cars))

        transactionService.fetchByDealerId(dealerId)
            .then(transactions => {
                setTransactions(transactions)
            })
            .catch(error => {
                console.error(error);
            });
    }

    useEffect(() => {
        if (isModalOpen) {
            refreshData()
        }
    }, [isModalOpen]);

    const handleClick = async (id,dealer_id) => {
        const inputAmount = textInputValues[id];
        var amountNum = Number(inputAmount);

        const inputValue = inputValues[id];
        var transaction_car_id = Number(inputValue);
         

        if ((inputAmount !== undefined && inputAmount !== '') && (inputValue !== undefined && inputValue !== '')) {
            const newTransaction = {
                amount: amountNum,
                description: "",
                car_id: inputValue,
                source_car_id: id,
                dealer_id: dealer_id,
                type_id: 1,
            }

            transactionService.addTransactionSource(newTransaction)
                .then(transactions => {
                    refreshData()
                    carService.fetchCars()
                })
                .catch(error => {
                    alert(t('InsufficientAmountError'))
                });
                 setTextInputValues({ ...textInputValues, [id]: '' }); 
        } else {

        }
    };

    const handleChange = (selectedOption, id) => {
        if (selectedOption) {
            setInputValues({ ...inputValues, [id]: selectedOption.value });
        } else {
            setInputValues({ ...inputValues, [id]: '' });
        }
    };

    const handleTextChange = (event, id) => {
        setTextInputValues({ ...textInputValues, [id]: event.target.value });
    };

    

      const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters
    
        if (!regex.test(keyValue)) {
          event.preventDefault();
        }
      };



    return (
        <>
            
            {dealerPage ? (
                <span className={cl.dealerBtn500} onClick={() => setIsModalOpen(true)}>{t('DealerReductions')}</span>
            ) : (
                <span className={cl.dealerBtn} style={{ display: 'block', width: '100%' }} onClick={() => setIsModalOpen(true)}>{(amount !== 0 ? amount : '')}</span>
            )}

            <Modal size="xl" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>{t('DealerCommissionWriteOffs')}</h3>
                    <div className={cl.balance}> {t('TransferableAmount')}:  <span> {sumOfAmountDeposit} </span>  </div>
                </div>



                <div style={{ position: 'relative', display: 'block', minHeight: 'unset' }}>

                    <div className={tbl.table} style={{ position: 'relative', display: 'block', minHeight: 'unset', marginBottom: '30px', overflow: 'unset' }}>
                        <table>
                            <thead>
                                <tr>
                                    <th className={cl.id} >#</th>
                                    <th>{t('From')}</th>
                                    <th>{t('Client')}</th>
                                    <th>{t('CommissionOnCar')}</th>
                                    <th>{t('CommissionOnTransport')}</th>
                                    <th>{t('InitialAmount')}</th>
                                    <th>{t('Balance')}</th>
                                    <th>{t('Transfer')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {depositCars ? (
                                    depositCars.map((car) =>
                                        <tr>
                                            <td>{car.id}</td>
                                            <td>{car.vin}</td>
                                            <td>{car.client?.firstname} {car.client?.lastname}  </td>
                                            <td><b> {car.client_price_dealer} $ </b></td>
                                            <td><b> {car.client_price_dealer_transport} $ </b></td>
                                            <td><b> {car.client_price_dealer + car.client_price_dealer_transport} $ </b></td>
                                            <td><b> {car.hasOwnProperty("total_spend_deposit") ? car.client_price_dealer + car.client_price_dealer_transport - car.total_spend_deposit : car.client_price_dealer + car.client_price_dealer_transport} $ </b></td>
                                            <td>
                                            {app.hasPermission("DEALER_PRICE_ADD") && 
                                                <div className={ cl.addForm }>
                                                    
                                                    <div style={{ minWidth: '230px' }}>
                                                        <Select
                                                            styles={selectStyle}
                                                            value={debtOptions.find((option) => option.value === inputValues[car.id])}
                                                            onChange={(option) => handleChange(option, car.id)}
                                                            options={debtOptions}
                                                            isClearable
                                                            placeholder={t('SelectCar')}
                                                        />
                                                    </div>

                                                    <div style={{ minWidth: '120px', maxWidth: '120px' }}>
  
                                                        <div className={ Form.priceInput } style={{ height: '35px' }}> 
                                                            <div className={ Form.priceCurrency }> 
                                                                USD
                                                            </div>
                                                            <input type="text"  
                                                                onKeyPress={handleKeyPress}
                                                                className={ Form.input }  
                                                                value={textInputValues[car.id] || ''}
                                                                onChange={(e) => handleTextChange(e, car.id)}  
                                                                min="0"/>
                                                            <div className={ Form.hundred } >.00</div>
                                                        </div>
                                                    </div>

                                                    <div onClick={() => handleClick(car.id, car.dealer.id)} className={ cl.btnsend } >{t('Transfer')}</div>


                                                      
                                                </div> 
                                             }
                                            </td>
                                        </tr>
                                    )
                                ) : (
                                    <tr>
                                        <td colSpan="8">{t('Loading')}...</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>

                </div>

                <div style={{ position: 'relative', display: 'block', minHeight: 'unset' }}>

                    <div className={tbl.table} style={{ position: 'relative', display: 'block', minHeight: 'unset' }}>
                        <table>
                            <thead>
                                <tr>
                                    <th className={cl.id} >#</th>
                                    <th>{t('From')}</th>
                                    <th>{t('To')}</th> 
                                    <th>{t('Amount')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions ? (
                                    transactions.map((transaction) =>
                                        <tr>
                                            <td>{transaction.id}</td>
                                             <td>{transaction.source_car ? transaction.source_car.vin : ""}</td> 
                                             <td> 
                                              
                                                {transaction.car.vin == transaction.source_car.vin ? t('CommissionRefund') : transaction.car.vin}
                                            
                                            </td> 
                                            <td><b> {transaction.amount} $ </b></td>
                                        </tr>
                                    )
                                ) : (
                                    <tr>
                                        <td colSpan="4">{t('Loading')}...</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>

                </div>

            </Modal>


        </>
    );
}

export default DealerDebtModal;